import React from "react";
export default class Info extends React.Component<any, any>{

    constructor(props) {
        super(props)
    }

    render() {
        const show = this.props.entity.SelectionType == 5;
        console.log(show)
        return (
            <div style={{ margin: "2px", display: show ? "flex" : "none", fontSize: "10px", flexDirection: "row-reverse" }}>
                <label>Dieser Typ wird nur in der App verwendet</label>
            </div>
        );
    }
}